import * as THREE from 'three';
import { PROFILE } from '../utils/profileConstants';

/**
 * Create a simple handle: a base plate + lever arm.
 */
export function createHandle(
  material: THREE.Material,
): THREE.Group {
  const group = new THREE.Group();
  group.name = 'handle';

  // Base plate
  const baseGeo = new THREE.BoxGeometry(
    PROFILE.handleWidth,
    PROFILE.handleHeight * 0.4,
    PROFILE.handleDepth * 0.3,
  );
  const base = new THREE.Mesh(baseGeo, material);
  base.position.set(0, 0, PROFILE.handleDepth * 0.15);
  group.add(base);

  // Lever
  const leverGeo = new THREE.BoxGeometry(
    PROFILE.handleWidth * 0.7,
    PROFILE.handleHeight * 0.5,
    PROFILE.handleWidth * 0.7,
  );
  const lever = new THREE.Mesh(leverGeo, material);
  lever.position.set(0, PROFILE.handleHeight * 0.25, PROFILE.handleDepth * 0.5);
  group.add(lever);

  // Connecting arm
  const armGeo = new THREE.BoxGeometry(
    PROFILE.handleWidth * 0.5,
    PROFILE.handleWidth * 0.5,
    PROFILE.handleDepth * 0.4,
  );
  const arm = new THREE.Mesh(armGeo, material);
  arm.position.set(0, PROFILE.handleHeight * 0.02, PROFILE.handleDepth * 0.35);
  group.add(arm);

  return group;
}
